/* src/app/self-enrollment/verification-inactive/verification-inactive.component.css */
.enroll {
  padding-bottom: 40px;
  background-image:
    linear-gradient(
      to bottom right,
      #dae5f0,
      white);
}
/*# sourceMappingURL=verification-inactive.component.css.map */
